import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';

const { WARNING_COLOR, WARNING_TEXT_COLOR } = colors;

const errorOccurredStyles = makeStyles(() => ({
	infoIcon: {
		color: WARNING_TEXT_COLOR,
		verticalAlign: 'middle',
		marginBottom: 2,
		paddingRight: '0.5em'
	},
	support: {
		backgroundColor: WARNING_COLOR,
		color: WARNING_TEXT_COLOR,
		height: 40,
		lineHeight: '40px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},
	padding: {
		paddingLeft: '1em'
	}
}));

export default errorOccurredStyles;
